<template>
  <div class="con">
    <!-- title -->
    <div class="title">
      <img class="title_bg" src="../assets/top2x.png" alt="">
      <div class="logo_box">
        <img class="logo_img" src="../assets/logo.png" alt="">
      </div>
      <div class="title_about">
        <div class="border"></div>
        <div class="about">主题征文活动</div>
        <div class="border"></div>
      </div>
      <!-- <div class="time">
        <span class="time_l">活动时间：</span>
        <span class="time_r">9月1日-10月30日</span>

      </div> -->
      <div class="organizer">
        <div class="organizer_t">
          <div class="organizer_t_l">主办单位：</div>
          <div class="organizer_t_r">
            <div>山东省国防动员办公室 山东省委宣传部</div>
            <div>山东省教育厅 山东省司法厅</div>
            <div>山东省人民政府国有资产监督管理委员会</div>
          </div>
        </div>
        <div class="organizer_b">
          <div class="organizer_b_l">承办单位：</div>
          <div class="organizer_b_r">
            <div>山东省互联网传媒集团</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 更多 -->
    <div class="content">
      <div class="more_top">
        <img src="../assets/more2x.png" alt="">
      </div>
      <!-- 作品 -->
      <div class="require">
        <img src="../assets/require2x.png" alt="">
        <div class="require_content">作品内容</div>
      </div>
      <div class="require_list">
        <p>围绕“我与国防动员”主题，聚焦国防动员建设各领域发展成就，深入挖掘国防动员工作中的生动实践与鲜活故事。作品可结合个人岗位实际、亲身经历和所见所感，以写实叙事、真情抒怀的方式，深刻阐释国防动员时代价值，全面展现国防动员事业高质量发展成效风貌。</p>
        <p class="last_margin">
          本次征文题目自拟、体裁不限，诗歌、散文、小说等均可，严禁采用讲话稿、工作总结等公文体例；作品字数原则上不超过2000字，要求兼具思想性、艺术性和可读性，内容积极向上、立意鲜明、情感真挚。
        </p>
      </div>
      <div class="require">
        <img src="../assets/require2x.png" alt="">
        <div class="require_content">作品要求</div>
      </div>
      <div class="require_list">
        <div class="require_list_item">
          <div class="require_list_item_num">1.</div>
          <div class="require_list_item_content">投稿年龄要求。本次征文活动对象为年满十八周岁的中华人民共和国公民，本次活动仅限成年社会各界人士及各类高等院校在校学生参与，不含高中及以下学段学生。</div>
        </div>
        <div class="require_list_item">
          <div class="require_list_item_num">2.</div>
          <div class="require_list_item_content">坚持正确政治导向。作品须严格遵守党的路线方针政策和宣传工作纪律，符合国家法律法规，践行社会主义核心价值观，内容健康向上、科学严谨。</div>
        </div>
        <div class="require_list_item">
          <div class="require_list_item_num">3.</div>
          <div class="require_list_item_content">紧扣主题创作立意。围绕国防动员职能定位和全民国防教育工作，聚焦我省国防动员建设发展成果、基层实践场景及个人感悟思考，多角度、多层次展现新时代国防动员事业高质量发展风貌。
          </div>
        </div>
        <div class="require_list_item">
          <div class="require_list_item_num">4.</div>
          <div class="require_list_item_content">
            严守原创合规要求。每位参与者投稿数量不超过2篇。所有参评作品须为作者原创、未公开发表、无版权争议，严禁抄袭、剽窃等违规行为。一经查实违规行为，即刻取消参评及获奖资格。投稿作者须对作品拥有独立、完整、无瑕疵的著作权，不得侵犯第三方著作权、肖像权、名誉权、隐私权等合法权益，凡因作品权属、内容合规等问题引发的一切纠纷及法律责任，均由投稿作者自行承担，主办方不承担任何责任。
          </div>
        </div>
        <div class="require_list_item">
          <div class="require_list_item_num">5.</div>
          <div class="require_list_item_content">
            规范作品使用授权。作品一经报送，即视为作者自愿授予主办方非营利性、永久性、非排他性公益使用权限。主办方有权对投稿作品进行编辑、节选、汇编、展播、宣传推广等公益使用，使用过程中依法保留作者署名权，不再另行支付稿酬。
          </div>
        </div>
        <div class="require_list_item last_margin">
          <div class="require_list_item_num">6.</div>
          <div class="require_list_item_content">严控AI创作使用规范。本次征文作品须为作者独立人工原创，严禁全文、主体内容由人工智能生成、续写、改写或批量润色。作品辅助性文字微调、格式校对等轻微AI辅助占比须严格控制，禁止以AI生成内容替代个人原创创作。所有参评作品须为作者真情实感原创成果，一经查实存在AI大规模生成、代写炮制等不实创作情形，直接取消参评及获奖资格，由此产生的一切争议与责任由作者自行承担。</div>
        </div>
      </div>
      <div class="require">
        <img src="../assets/require2x.png" alt="">
        <div class="require_content">评选及奖项</div>
      </div>
      <div class="require_list">
        <p>本次活动坚持公平、公正、公开原则，由省级主流媒体组建专业评审团队开展分类评审。活动设置四大作品评选类别，所有参赛作品统一统筹评审。奖项共设置：一等奖20名、二等奖30名、三等奖40名、优秀奖60名。评审结合各类别作品评审标准综合择优评定，评审结果将在山东省国防动员办公室官方网站、“山东国防动员”微信公众号及省级主流媒体平台公示。</p>
        <!-- <p>奖项共设置：</p> -->
        <p class="">（一）评选类别及评审标准：一是叙事类作品。面向叙事类作品，依据故事质感、情感表达、感染力及主题契合度评审，择优选取故事生动、情感真挚、贴合国防动员实践的优质作品。二是创新视角类作品。面向视角新颖、创意突出的作品，依据选题新意、立意深度、内容亮点评审，择优选取视角独特、立意深刻、展现国防动员建设新风貌的优质作品。三是诗意表达类作品。面向诗歌、散文诗等文体，依据文笔质感、意境氛围、主题表现力评审，择优选取文笔优美、意境深远、国防动员主题鲜明的文艺作品。四是青年参赛作品。本类别专门面向年满十八周岁的各类高等院校在校学生（不含高中及以下学段学生），依据创作质量、精神风貌、国防动员认知度评审，择优选取积极向上、创作优质、彰显新时代学子国防担当的作品。</p>
        <p class="">（二）评审与奖项说明：<br>&emsp;&emsp;1、评审方式：本次活动四类作品统筹评审，结合各类别专属标准综合打分、择优定级。奖项名额为活动全局总名额，评审工作将结合本次活动稿件实际征集数量、作品整体质量综合统筹评定，可根据实际征集情况合理适配调整，确保评审公平公正、贴合活动实际。
<br>&emsp;&emsp;2、奖项奖励：获奖作品颁发荣誉证书及活动纪念品。
<br>&emsp;&emsp;3、成果展示：获奖名单及优秀作品将在“山东国防动员”微信公众号、大众网・海报新闻等平台集中展示推广。
</p>
        <!-- <p class="nosuojin">（三）作品奖项设置。一等奖20名，作品立意深远、质量精湛、感染力强，贴合活动主题，具备示范价值与传播意义；二等奖30名，作品内容优质、主题贴合、完成度高，较好展现国防动员工作风貌与时代特色；三等奖40名，作品合规完整、主题积极、创作态度严谨，符合本次活动参赛标准；优秀奖60名，作品紧扣活动主题、内容完整，积极参与活动，充分展现国防教育传播成效。</p> -->
        <!-- <p class="nosuojin">（四）新生力量奖50名。面向中小学生参赛群体设立，表彰积极参与、创作优质、富有朝气的青少年参赛作品。</p>
        <p class="nosuojin">（五）优秀组织奖10名。表彰高度重视活动开展、组织动员有力、稿件报送数量充足、作品质量突出的单位集体。</p> -->
        <p class="last_margin">
          （三）作品奖项设置：一等奖20名，作品立意深远、质量精湛、感染力强，贴合活动主题，具备示范价值与传播意义；二等奖30名，作品内容优质、主题贴合、完成度高，较好展现国防动员工作风貌与时代特色；三等奖40名，作品合规完整、主题积极、创作态度严谨，符合本次活动参赛标准；优秀奖60名，作品紧扣活动主题、内容完整，积极参与活动，充分展现国防教育传播成效。
        </p>
      </div>
      <!-- 在线投稿 -->
      <div class="jump" @click="jump">
        <img src="../assets/baoming.png" alt="">
        <!-- <div class="jump_text">在线投稿</div> -->
      </div>
      <div class="require_list">
        <div class="require_list_title">活动注意事项</div>
        <div class="require_list_item">
          <div class="require_list_item_num">1.</div>
          <div class="require_list_item_content">稿件征集截止时间为10月10日17:00</div>
        </div>
        <div class="require_list_item">
          <div class="require_list_item_num">2.</div>
          <div class="require_list_item_content">投稿作品版权归山东省国防动员办公室及作者共同所有，山东省国防动员办公室有权对作品进行宣传等使用。</div>
        </div>
        <!-- <div class="require_list_item">
          <div class="require_list_item_num">3.</div>
          <div class="require_list_item_content">
            <div>联系人</div>
            <div>
              <div>郭老师 0531—51768667</div>
              <div>郭老师 0531—51768667</div>
            </div>
          </div>
        </div> -->
        <div class="require_list_item">
          <div class="require_list_item_num">3.</div>
          <div class="require_list_item_content">
            <div class="require_list_item_content_l">联系人：</div>
            <div class="require_list_item_content_r">
              <div class="user">郭老师 0531-51768667</div>
              <div class="user">王老师 0531-85196604</div>
             
            </div>
          </div>
        </div>
        <div class="require_list_item last_margin">
          <div class="require_list_item_num">4.</div>
          <div class="require_list_item_content">
           咨询电话在线时间：周一至周五上午9：00-11：30,下午14：00-17：30
          </div>
        </div>
      </div>
      <!-- <div class="bottom">j</div> -->
      <!-- 结束 -->
    </div>

  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  name: '',
  components: {
  },
  props: {},
  data () {
    return {
      index: 1,
      fileList: []
    }
  },
  computed: {},
  watch: {},
  created () { },
  mounted () { },
  methods: {
    jump () {
      this.$router.push('/apply')
      // Toast({
      //   message: '请在活动时间\n9.1日-9.30日内提交',
      //   duration: 2000,
      //   type: 'text',
      //   position: 'top'
      // })
    },
  }
}
</script>

<style scoped lang="less">
.con {
  background-color: #c71f1f;
  position: relative;
  width: 375px;
  height: auto;
  overflow: hidden;
  padding-bottom: 30px;
  margin: 0 auto;
  .title {
    position: relative;
    width: 375px;
    height: 814px;
    overflow: hidden;
    margin: 0;
    padding: 0;
    .title_bg {
      width: 100%;
      height: 100%;
    }
    .logo_box {
      width: 61px;
      height: 61px;
      overflow: hidden;
      position: absolute;
      top: 19px;
      left: 50%;
      transform: translateX(-50%);
      .logo_img {
        width: 100%;
        height: 100%;
      }
    }
    .title_about {
      // width: 228px;
      width: 280px;
      height: 27px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      // top: 164px;
      top: 184px;
      left: 50%;
      transform: translateX(-50%);
      .border {
        width: 52px;
        height: 0px;
        border: 1px solid #ffffff;
        position: relative;
        top: 2px;
      }
      .about {
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 500;
        // font-size: 18px;
        font-size: 22px;
        color: #ffffff;
        text-align: justified;
        font-style: normal;
        text-transform: none;
      }
    }
    .time {
      position: absolute;
      width: 209px;
      height: 29px;
      top: 203px;
      left: 50%;
      transform: translateX(-50%);
      background-image: url("../assets/time2.png");
      background-size: 100% 100%; /* 铺满整个区域 */
      background-repeat: no-repeat; /* 不重复 */
      text-align: center;
      line-height: 29px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #c71f1f;
      font-style: normal;
      text-transform: none;
      overflow: hidden;
      .time_r {
        font-weight: 700;
      }
    }
    .organizer {
      width: 284px;
      height: 78px;
      position: absolute;
      top: 512px;
      left: 50%;
      transform: translateX(-50%);
      .organizer_t {
        width: 100%;
        height: 54px;
        display: flex;
        justify-content: left;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        text-align: left;
        font-style: normal;
        text-transform: none;
        line-height: 18px;
        white-space: nowrap; /* 防止文本换行 */
        overflow: visible; /* 不隐藏超出部分，让内容可见 */
        .organizer_t_l {
          min-width: 60px;
        }
        .organizer_t_r {
          width: 400px;
          margin-left: 6px;
        }
      }
      .organizer_b {
        width: 100%;
        height: 18px;
        margin-top: 6px;
        display: flex;
        justify-content: left;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        text-align: left;
        font-style: normal;
        text-transform: none;
        line-height: 18px;
        white-space: nowrap; /* 防止文本换行 */
        overflow: visible; /* 不隐藏超出部分，让内容可见 */
        .organizer_b_l {
          min-width: 60px;
        }
        .organizer_b_r {
          width: 400px;
          margin-left: 6px;
        }
      }
    }
  }
  // 更多
  .content {
    width: 375px;
    position: relative;
    // top: -210px;
    // transform: translateY(-210px);
    margin-top: -210px;
    .more_top {
      width: 375px;
      height: 16px;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 作品相关
    .require {
      // width: 246px;
      width: 236px;
      height: 50px;
      overflow: hidden;
      margin: 16px auto 8px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .require_content {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        width: auto;
        height: 50px;
        line-height: 50px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 16px;
        color: #d21b1b;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
    }
    .require_list {
      width: 327px;
      // height: 292px;
      height: auto;
      background: #fffdf1;
      border-radius: 8px 8px 8px 8px;
      padding: 20px 20px;
      // padding: 16px 20px;
      box-sizing: border-box;
      margin-left: 50%;
      transform: translateX(-50%);
      .require_list_title {
        width: 104px;
        height: 25px;
        background: rgba(199, 31, 31, 0.82);
        border-radius: 30px 30px 30px 30px;
        text-align: center;
        margin-bottom: 10px;
        margin-left: 50%;
        transform: translateX(-50%);
        line-height: 25px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      p {
        margin: 0 0 10px;
        text-indent: 2em; /* 首行缩进两个字符 */
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #880612;
        text-align: justify;
        font-style: normal;
        text-transform: none;
        line-height: 22px;
      }
      .require_list_item {
        width: 287px;
        height: auto;
        overflow: hidden;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        margin: 0 0 10px;
        // text-indent: 2em; /* 首行缩进两个字符 */
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        color: #880612;
        text-align: justify;
        font-style: normal;
        text-transform: none;
        line-height: 22px;
        .require_list_item_num{
          width: 20px;
          height: 20px;
        }
        .require_list_item_content{
          width: 267px;
          display: flex;
          justify-content: flex-start;
          .require_list_item_content_l{
            width: auto;
            height: 20px;
          }
          .require_list_item_content_r{
            flex: 1;
          
          }

        }
        
      }
      .last_margin {
        margin-bottom: 0 !important;
      }
      .nosuojin{
        text-indent: 0;
      }
    }
    // 在线投稿
    .jump {
      width: 224px;
      height: 54px;
      margin: 32px 0 26px 50%;
      transform: translateX(-50%);
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
      .jump_text {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        height: 48px;
        line-height: 48px;
        // width: 72px;
        font-family: Source Han Sans CN, Source Han Sans CN;
        font-weight: bold;
        font-size: 18px;
        color: #c71f1f;
        text-align: justified;
        font-style: normal;
        text-transform: none;
      }
    }
    .bottom {
      margin-top: 20px;
      height: 20px;
      background-color: #fff;
    }
  }
}
</style>